/**
 * Folder-related constants
 */

/**
 * Special folder IDs used for virtual folders (recents, private, shared, trash)
 */
export const SPECIAL_FOLDER_IDS = {
  RECENTS: 'recents',
  PRIVATE: 'private',
  SHARED: 'shared',
  TRASH: 'trash',
} as const;

/**
 * Check if a folder ID is a special folder
 */
export const isSpecialFolder = (folderId?: string | null): boolean => {
  if (!folderId) return false;
  return Object.values(SPECIAL_FOLDER_IDS).includes(
    folderId as (typeof SPECIAL_FOLDER_IDS)[keyof typeof SPECIAL_FOLDER_IDS],
  );
};

/**
 * Maximum number of other users to display in avatar list before showing +N
 */
export const MAX_VISIBLE_AVATARS = 1;
